import { fade } from "@material-ui/core/styles/colorManipulator";

const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles(({ palette: { primary, custom } }) => ({
  menu: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  menuItem: {
    width: "100%",
    height: 36,
    padding: "0 12px 0 12px",
    border: 0,
    background: "transparent",
    fontSize: "1rem",
    color: primary.main,
    cursor: "pointer",
    outline: "none",
    textAlign: "left",
    "&:hover": {
      background: fade(custom.low, 0.1),
    },
    "&:focus": {
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  menuItem_selected: {
    background: fade(primary.main, 0.16),
    cursor: "default",
    "&:hover": {
      background: fade(primary.main, 0.16),
    },
  },
}));

export default useStyles;
